import React from 'react';

import { MobileNavbar } from './mobile-navbar';

export type MobileNavbarParams = {
  toggleMenu: () => void;
  showSummary?: () => void;
  showVideo?: () => void;
};

export const MobileNavbarContainer: React.FC<MobileNavbarParams> = ({
  toggleMenu,
  showSummary,
  showVideo,
}) => {
  return <MobileNavbar showSummary={showSummary} showVideo={showVideo} toggleMenu={toggleMenu} />;
};
